var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("svg", { staticClass: "icon", attrs: { viewBox: "0 0 22 21" } }, [
    _c(
      "g",
      {
        attrs: {
          id: "Symbols",
          "stroke-width": "2",
          fill: "none",
          "fill-rule": "evenodd",
          "stroke-linecap": "square",
        },
      },
      [
        _c(
          "g",
          {
            attrs: {
              id: "Cart-Slideout",
              transform: "translate(-549.000000, -33.000000)",
              stroke: _vm.stroke,
            },
          },
          [
            _c(
              "g",
              {
                attrs: {
                  id: "icon--cross",
                  transform: "translate(548.000000, 32.000000)",
                },
              },
              [
                _c("g", { attrs: { id: "Line-2" } }, [
                  _c("path", {
                    attrs: {
                      d: "M1.5625,1.5625 L21.9350075,21.9350075",
                      "fill-rule": "nonzero",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      d: "M1.5625,21.9350075 L21.9350075,1.5625",
                      "fill-rule": "nonzero",
                    },
                  }),
                ]),
              ]
            ),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }